import base from "./base.service"
const addSponsor = payload => base.post("sponsor-requests/add", payload)
const sponsorRequesterList = payload => base.get("sponsor-requests/list", { params: payload })
const sponsorList = () => base.get(`/sponsors/list`)
const sponsorRequestDetails = id => base.get(`/sponsor-requests/sponsorRequest/${id}`)
const denySponsorPayment = id => base.get(`sponsor-requests/denyPayment/${id}`)

export const sponsorService = {
    addSponsor,
    sponsorList,
    sponsorRequesterList,
    sponsorRequestDetails,
    denySponsorPayment

}